import React, { useEffect, useState } from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'

const BlacklistFilter = ({ cardNumber,setBlackList, value,filterData ,setFilterData}) => {
    const [tapNumber,setTapNumber] = useState(null);
  useEffect(() => {
    if(cardNumber!=tapNumber){
      setTapNumber(cardNumber);
      setBlackList([])
    }
    if(filterData!==false){
      setFilterData(false)
      setBlackList([])
    }
  },[cardNumber,filterData])
  const options = [
    {
      label: 'Bad conduct',
      value: 'BAD_CONDUCT',
      checked: true,
    },
    {
      label: 'Fees not paid',
      value: 'FEES_NOT_PAID',
      checked: true,
    },
    {
      label: 'Low attendance',
      value: 'LOW_ATTENDANCE',
      checked: true,
    },
  ]
  const onChange = checkedValues => {
    setBlackList(checkedValues)
  }
  return (
    <FilterCheckBoxComp options={options} value={value} onChange={onChange} />
  )
}

export default BlacklistFilter
